export function menu() {
	// Sorgt für die Funktion des Hamburgers und das Umschalten des Mobile-Menüs
	$('.header__menu-toggle').on('click', function (e) {
		e.preventDefault()

		$('.hamburger').toggleClass('is-active')
		$('.navigation-container').toggleClass('is-active')
	})
}
